<template>
	<AtomLink
		class="flex items-center gap-4 group"
		v-bind="item.to"
	>
		<span class="inline-flex items-center gap-4">
			<span class="group-hover:underline">{{ item.text }}</span>
			<span
				v-if="counter"
				class="rounded-full h-8 w-8 bg-red-400 text-white text-center inline-flex items-center justify-center"
			>
				{{ counter }}
			</span>
		</span>
		<AtomFontAwesome
			icon="fa-arrow-right"
			class="w-4 h-4"
		/>
	</AtomLink>
</template>

<script lang="ts" setup>
import type { MenuItemType } from '#base/core/types/MenuItemType';

const {
	item,
} = defineProps<{ item: MenuItemType }>();

const counter = ref<number>();

onMounted(async () => {
	if (!item.counter) {
		return;
	}

	if (typeof item.counter === 'number') {
		counter.value = item.counter;

		return;
	}

	counter.value = await item.counter;
});
</script>
